
    <div class="modal-dialog">
      <div class="modal-content">
        <ng-content></ng-content>
      </div>
    </div>